<template>
  <div>
    <router-link to="/systemuser/erstellen" class="btn btn-primary"
      >Benutzer Erstellen</router-link
    >
    <v-table
      class="customer-list-table"
      url="/api/v1/user"
      :filter="filter"
      :appends="['delete_url']"
      :row-classes="{
        'table-disabled': model => {
          return Boolean(model.disabled_at);
        },
        'table-deleted': model => {
          return Boolean(model.deleted_at);
        },
        'table-deletion': model => {
          return Boolean(model.deletion_at);
        }
      }"
      :attributes="[
        {
          attribute: 'id',
          name: 'ID'
        },
        {
          attribute: 'name',
          name: 'Name',
          type: 'SystemUserNameCell'
        },
        {
          attribute: 'email',
          name: 'E-Mail-Adresse'
        },
        {
          attribute: 'created_at',
          name: 'Registrierdatum'
        },
        {
          attribute: 'roles',
          name: 'Rollen',
          type: 'RolesCell',
          sortable: false
        },
        {
          attribute: 'permissions',
          name: 'Permissions',
          type: 'PermissionsCell',
          sortable: false
        },
        {
          attribute: 'id',
          name: 'Aktionen',
          type: 'SystemUserActionCell',
          sortable: false
        }
      ]"
    >
      <template v-slot:filter>
        <table-filter
          :filterComponents="[
            {
              type: 'TakeFilter',
              name: 'take'
            },
            {
              type: 'WhereFilter',
              label: 'ID',
              attributes: 'id'
            },
            {
              type: 'WhereLikeFilter',
              label: 'E-Mail-Adresse',
              attributes: 'email'
            },
            {
              type: 'WhereLikeFilter',
              label: 'Name',
              attributes: 'name'
            },
            {
              type: 'DateFilter',
              label: 'Registrierdatum von',
              attributes: { column: 'created_at', operator: '>=' }
            },
            {
              type: 'DateFilter',
              label: 'Registrierdatum bis',
              attributes: { column: 'created_at', operator: '<=' }
            },
            {
              type: 'RoleFilter'
            },
            {
              type: 'PermissionFilter'
            }
          ]"
          v-model="filter"
          @apply-filters="$bus.$emit('refresh-table')"
        ></table-filter>
      </template>
    </v-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filter: [
        {
          name: "with",
          value: ["roles", "permissions"]
        }
      ]
    };
  }
};
</script>

<style></style>
